<template>
	<section>
		<vFormItem class="width-80per" label-width="auto" :label="$t('global.common.warehouse', { defaultValue: '仓库' })" prop="system" :rules="required">
			<vSelect v-model="warehouseIds" filterable  multiple>
				<vOption
					v-for="item in getWarehouseAllList"
					:value="item.value"
					:key="item.value"
				>{{item.label}}</vOption>
			</vSelect>
		</vFormItem>
		<compUpload v-bind="getFileProps" @on-close="close" @on-update="update"></compUpload>
	</section>
</template>
<script>
import { mapGetters } from "vuex";
import { HttpGetInventoryCodeMapTemplate } from "@/service/inventory";
export default {
	components: {
		compUpload: () => import("@components/templates/upload"),
	},
	data() {
		return {
			warehouseIds: [],
		}
	},
	computed: {
		...mapGetters('dictionary', ['getWarehouseAllList']),
		getFileProps() {
			return {
				action: process.env.VUE_APP_APIURL_FBB + '/api/v2/inventory/codeMap/fileImport',
				name: "excelFile",
				data: {
					orgWarehouseIds: this.warehouseIds.join(','),
				},
				download: () => {
					this.handleWebfs(HttpGetInventoryCodeMapTemplate, {}, {
						download: true,
						executor: "request"
					})
				},
			}
		},
	},
	methods: {
		close() {
			this.$emit('on-close')
        },
        update(){
            this.$emit('on-update')
        }
	}
}
</script>
